import React from "react";
import { Box } from "@mui/material";
import { SPECS, specsParticleDrift } from "./specsTheme";

const PARTICLES = [
  { left: "8%", delay: "0s", duration: "11s", size: 4, color: SPECS.magenta },
  { left: "18%", delay: "2s", duration: "14s", size: 3, color: SPECS.orange },
  { left: "32%", delay: "4s", duration: "12s", size: 5, color: SPECS.gold },
  { left: "48%", delay: "1s", duration: "15s", size: 3, color: SPECS.magenta },
  { left: "62%", delay: "3.5s", duration: "13s", size: 4, color: SPECS.orange },
  { left: "74%", delay: "5s", duration: "16s", size: 3, color: SPECS.gold },
  { left: "86%", delay: "0.8s", duration: "12.5s", size: 4, color: SPECS.magentaDeep },
  { left: "94%", delay: "2.8s", duration: "14.5s", size: 3, color: SPECS.orange },
];

const AmbientParticles = () => (
  <Box
    aria-hidden
    sx={{
      position: "absolute",
      inset: 0,
      overflow: "hidden",
      pointerEvents: "none",
      zIndex: 0,
    }}
  >
    {PARTICLES.map((p, i) => (
      <Box
        key={i}
        sx={{
          position: "absolute",
          bottom: "-8%",
          left: p.left,
          width: p.size,
          height: p.size,
          borderRadius: "50%",
          bgcolor: p.color,
          boxShadow: `0 0 12px ${p.color}`,
          opacity: 0,
          animation: `${specsParticleDrift} ${p.duration} linear infinite`,
          animationDelay: p.delay,
        }}
      />
    ))}
  </Box>
);

export default AmbientParticles;
